module.exports = __webpack_public_path__ + "img/5m.69d3393e.png";